import React from 'react';

import RoutingComponents from '../../../RoutingComponets';

const TouzenLegacyRoutes = () => {
  return <RoutingComponents />;
};

export default TouzenLegacyRoutes;
